export default "__VITE_ASSET__rZmokNNg__"